import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["status"]
  static values = { destination: String, preview: Boolean }

  connect() {
    this.active = true
    // Mark the intro as seen as soon as it opens, including when skipped.
    // The explicit skip URL also works when cookies are disabled.
    if (!this.previewValue && document.cookie.split(";").some(cookie => cookie.trim() === "intro_seen=1")) {
      this.leave()
      return
    }
    this.markSeen()
    this.element.querySelectorAll("[data-logo-piece]").forEach(piece => piece.removeAttribute("style"))
    this.play()
  }

  piece(name) {
    return this.element.querySelector(`[data-logo-piece="${name}"]`)
  }

  markSeen() {
    document.cookie = `intro_seen=1; Path=/; Max-Age=34560000; SameSite=Lax${location.protocol === "https:" ? "; Secure" : ""}`
  }

  skip(event) {
    event.preventDefault()
    this.markSeen()
    this.leave()
  }

  leave() {
    this.disconnect()
    // Replace the intro in browser history so Back does not replay it.
    window.location.replace(this.destinationValue)
  }

  disconnect() {
    this.active = false
    cancelAnimationFrame(this.frame)
    clearTimeout(this.redirectTimer)
  }

  play() {
    const interval=.65, period=interval*3, end=6.65;
    const pieces=[
     {id:'first',x:258,height:270,last:3.9,turn:-1},
     {id:'second',x:554,height:325,last:4.55,turn:1},
     {id:'two',x:880,height:235,last:5.2,turn:-1}
    ];
    const ease=t=>t*t*(3-2*t);
    const mix=(a,b,t)=>a+(b-a)*t;
    const pose = (piece,x,y,scale,angle) => {
     this.piece(piece.id).setAttribute('transform',`translate(${x} ${y}) rotate(${angle}) scale(${scale}) translate(${-piece.x} -275)`);
    }
    const render = (t) => {
     pieces.forEach((piece,i)=>{
      // The original shapes are ~396 px high; a .48 scale gives 190 px.
      const contact=piece.id==='two'?507:490;
      if(t>=piece.last){
       const u=Math.min(1,(t-piece.last)/1.45),e=ease(u);
       pose(piece,piece.x,mix(contact,275,e)-180*4*u*(1-u),mix(.48,1,e),piece.turn*360*(1-e));
      }else{
       const elapsed=((t-i*interval)%period+period)%period;
       const u=elapsed/period;
       pose(piece,piece.x,contact-piece.height*4*u*(1-u),.48,piece.turn*(u*360));
      }
     });
     // Move to the next impact while all pieces are airborne. Brief upward
     // strokes coincide with contact; after the final hit the paddle rests.
     const stop=5.2;
     const k=Math.min(8,Math.floor(t/interval));
     const u=Math.min(1,(t-k*interval)/interval);
     const x=t>=stop?880:mix(pieces[k%3].x,pieces[(k+1)%3].x,ease(u));
     const pulse=t>=stop?Math.max(0,1-(t-stop)/.22):Math.max(0,1-u/.28);
     this.piece('paddle').setAttribute('transform',`translate(${x} ${610-25*pulse})`);
    }

    const finish = () => {
      this.statusTarget.textContent = "002. Ready to play."
      this.redirectTimer = setTimeout(() => this.leave(), 3000)
    }
    if (matchMedia("(prefers-reduced-motion: reduce)").matches) {
      render(end)
      finish()
      return
    }
    const start = performance.now()
    const tick = now => {
      if (!this.active) return
      // Firefox timestamp rounding can put the first frame before start.
      const t = Math.max(0, Math.min(end, (now - start) / 1000))
      render(t)
      if (t < end) this.frame = requestAnimationFrame(tick)
      else finish()
    }
    render(0)
    this.frame = requestAnimationFrame(tick)
  }
}
